export default {
  '10': '请输入金额'
}
